import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import Balloon from "../balloon";
import { logEvent } from "../../utils";

function RequestAccessBalloon(): JSX.Element {
  const { pathname } = useRouter();

  const [shown, setShown] = useState(pathname !== "/");

  useEffect(() => {
    if (shown || pathname === "/") {
      return;
    }

    setShown(true);
  }, [shown, pathname, setShown]);

  return (
    <>
      {shown && (
        <Balloon>
          <a
            href="https://airtable.com/shr4ZEk5YWZzQlyKk"
            onClick={() => logEvent("button:click", "early-access", "balloon")}
          >
            Sign up for early access
          </a>
        </Balloon>
      )}
    </>
  );
}

export default RequestAccessBalloon;
